import { getHttpClient } from '../../../../shared/utils/http-client.ts/index';
import { Group } from '../models/group';
import { deleteGroupEndpoint } from './const';

export const deleteGroup = (group: Group) => {
    group.isDeleted = true;
    return getHttpClient().post({ url: deleteGroupEndpoint, data: JSON.stringify(group) });
};
